<!-- ライフエール独自対応 -->
<template>
  <div class="p-personal-information-modal">
    <AuthModal
      ref="personal-information-modal"
      width-size="LL"
      htmlTitle="ライフエール／ライフエール（子育て応援クラブ特典）利用規約"
    >
      <div>
        <div v-html="this.getPolicy" class="c-modal__inner"></div>
        <div class="c-buttons p-personal-information-modal__buttons">
          <div class="c-buttons4__inner c-buttons4__inner--spOrder1">
            <div class="c-buttonWrap4" @click="loggedOut">
              <CButton style-type="primary" color="color4"> 同意しない </CButton>
            </div>
          </div>
          <div class="c-buttons4__inner c-buttons4__inner--spOrder0">
            <div class="c-buttonWrap4" @click="loggedIn">
              <CButton style-type="primary" color="color2"> 同意する </CButton>
            </div>
          </div>
        </div>
      </div>
    </AuthModal>
  </div>
</template>

<script>
import Vue from 'vue'
import AuthModal from '@crly/views/AuthModal'

Vue.component("AuthModal", AuthModal)

export default {
  data() {
    return {
      loading: false,
      isSubscribe: true,
      getPolicy: ""
    };
  },
  mounted() {
    this.getUserPolicy();
  },
  methods: {
    async getUserPolicy() {
      const policy = await this.$repositories("auth").getTermsInformation();
      this.getPolicy = policy.data.userPolicyText;
    },
    // 同意する
    async loggedIn() {
      this.loading = true
      this.$refs["personal-information-modal"].hide();
      // 利用規約同意登録
      await this.$repositories("auth").getAgreeRegister();
      this.$emit("submit", {
        isSubscribe: this.isSubscribe
      });
    },
    // 同意しない
    async loggedOut() {
      this.loading = true
      this.$refs["personal-information-modal"].hide();
      // ログアウト
      this.logout();
    },
    show() {
      this.$refs["personal-information-modal"].show();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_foundation/_variable-colors.scss";
@import "@/views/pages/c-button.scss";
@import "@/components/LifeYell/assets/css/c-buttonWrap.scss";
@import "@/components/LifeYell/assets/css/c-modal.scss";
@import "@/components/LifeYell/assets/css/p-personal-information-modal.scss";
.c-modal {
  position: relative;
  display: block;
  justify-content: center;
  z-index: 1500;
  align-items: flex-end;
  background-color: white;
  border-radius: 12px 12px 0 0;
}
.c-modal__inner {
  width: 100%;
  max-width: 100%;
  max-height: calc(var(--height) - 16rem);
}
.p-personal-information-modal {
  margin-top: -72px;
  background-color: rgba(31, 32, 33, 0.64);
}
.c-button {
  font-size: 16px;
  font-family: "Arial";
}
</style>
<style lang="scss">
section {
  padding: 0;
}
</style>
